exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-height[data-v-6f612d13]{height:calc(100% - 95px)}.detail-height[data-v-6f612d13]{height:calc(100% - 50px)}", ""]);

// exports
